<template>
  <div v-if="visible" class="nixia-typing-indicator-row">
    <div class="nixia-typing-indicator-avatar">
      <img src="https://espaco.blob.core.windows.net/nixloc-imagens/logo_ia.png" alt="Nixia" class="nixia-typing-indicator-avatar-img" />
    </div>
    <div class="nixia-typing-indicator-bubble">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NixiaTypingIndicator",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.nixia-typing-indicator-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.nixia-typing-indicator-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
  overflow: hidden;
}

.nixia-typing-indicator-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nixia-typing-indicator-bubble {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 14px 16px;
  background: var(--bg-elevated);
  border-radius: 14px;
  border-bottom-left-radius: 4px;
  min-width: 60px;
}

.nixia-typing-indicator-bubble span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--text-muted);
  animation: nixia-typing-blink 1.2s infinite ease-in-out;
  display: inline-block;
}

.nixia-typing-indicator-bubble span:nth-child(2) {
  animation-delay: 0.2s;
}

.nixia-typing-indicator-bubble span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes nixia-typing-blink {
  0%, 80%, 100% { opacity: 0.2; transform: scale(0.85); }
  40%           { opacity: 1;   transform: scale(1.15); }
}
</style>
